import { API_BASE_URL } from "../config";
import { api } from "./api";

const SUPPORT_BASE = `${API_BASE_URL}/api/support`;

async function parseJson(response) {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message =
      data?.error ||
      data?.message ||
      "Something went wrong while calling support API";
    const error = new Error(message);
    error.status = response.status;
    error.details = data?.details || null;
    throw error;
  }

  return data;
}

export async function createSupportTicket(payload) {
  const response = await fetch(`${SUPPORT_BASE}/tickets`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return parseJson(response);
}

export async function getMySupportTickets(walletAddress) {
  const response = await fetch(
    `${SUPPORT_BASE}/tickets?walletAddress=${encodeURIComponent(walletAddress)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return parseJson(response);
}

export async function getSupportTicketById(publicId, walletAddress) {
  const normalizedWallet = String(walletAddress || "").trim();

  if (!normalizedWallet) {
    throw new Error("Wallet address is required to load this support ticket.");
  }

  const response = await fetch(
    `${SUPPORT_BASE}/tickets/${encodeURIComponent(
      publicId
    )}?walletAddress=${encodeURIComponent(normalizedWallet)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return parseJson(response);
}

export async function getAdminSupportTicketById(publicId) {
  const response = await api.get(
    `/api/support/admin/tickets/${encodeURIComponent(publicId)}`
  );

  return response.data;
}

export async function replyToSupportTicket(publicId, walletAddress, message) {
  const response = await fetch(
    `${SUPPORT_BASE}/tickets/${encodeURIComponent(publicId)}/replies`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        walletAddress,
        message,
      }),
    }
  );

  return parseJson(response);
}

export async function replyToSupportTicketAsAdmin(publicId, message) {
  const response = await api.post(
    `/api/support/admin/tickets/${encodeURIComponent(publicId)}/replies`,
    {
      message,
    }
  );

  return response.data;
}

export async function updateSupportTicketStatusAsAdmin(publicId, status) {
  const response = await api.patch(
    `/api/support/admin/tickets/${encodeURIComponent(publicId)}/status`,
    {
      status,
    }
  );

  return response.data;
}